export default __webpack_public_path__ + "static/media/20200926_145754.1d2b9d4f.jpg";